import AService from '@/services/AService'

const ENTITY_NAME = 'export';

export default class ExportService extends AService {

  /**
   * Export des kpi
   * @return {Promise<Blob>}
   */
  async kpi(){
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/kpi`, {responseType: 'blob'});
    return response.data;
  }

  /**
   * @param {LineIdFilter} filter
   * @return {Promise<any>}
   */
  async lineId(filter){
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/lineId`, {responseType: 'blob', params: filter});
    console.log(response.headers);
    return {
      content : response.data,
      fileName : response.headers['content-disposition'].split('filename=')[1]
    };
  }

  exportEventData(response) {
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const date = new Date().toISOString().split('T');
    link.setAttribute('download', 'export_' + date[0] + '_' + date[1].split('.')[0] + '.zip');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
